import axiosClient from "../../api/axiosClient";

export const runMigrationsInServer = async () => {
  const response = await axiosClient.post("/initialization/runMigrations");
  return response.data;
};

export const createAdminInServer = async () => {
  const response = await axiosClient.post("/initialization/createAdmin");
  return response.data;
};